(function () {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputSearchSelect', cpInputSearchSelect);

    cpInputSearchSelect.$inject = ['$q', 'lodashService'];

    function cpInputSearchSelect($q, lodashService) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-search-select/input-search-select.html',
            scope: {
                title: '@',
                labelClass: '@?',
                containerClass: '@',
                fullWidth: '@',
                object: '=',
                prop: '@',
                options: '=',
                optionPropTitle: '@',
                optionPropValue: '@',
                optionPropExtraPk: '@',
                optionPropExtraTitle: '@',
                optionPropGroupBy: '@?',
                optionFilter: '&?',
                isRequired: '=?',
                isDisabled: '=?',
                isMultiple: '=?',
                onChange: '&?',
                withLoading: '=?',
                queryProp: '@?',
                onSearch: '&?',
                selectObject: '=?'
            },
            link: function (scope, element, attrs, controller) {
                var _selected = null;

                scope.page = 1;
                scope.getLabelClass = getLabelClass;
                scope.getContainerClass = getContainerClass;
                scope.isWithLabel = isWithLabel;

                scope.evalOptionFilter = evalOptionFilter;
                scope.getNextPage = getNextPage;
                scope.search = search;

                scope.onBlur = onBlur;
                scope.onItemRemove = lodashService.debounce(onItemRemove, 1000);
                scope.clearAll = clearAll;
                scope.getItem = getItem;
                scope.getItemTitle = getItemTitle;

                activate();

                function activate() {
                    _selected = lodashService.filter(scope.options, function (option) {
                        return lodashService.includes(scope.object[scope.prop], option.value);
                    });
                }

                function getNextPage($select) {
                    if (!scope.withLoading) {
                        return;
                    }

                    if (scope.loading) {
                        return;
                    }

                    if (!scope.onSearch) {
                        return;
                    }

                    scope.page += 1;
                    scope.loading = true;

                    var data = {
                        page: scope.page
                    };
                    data[scope.queryProp] = $select.search;

                    $q.all([scope.onSearch({params: data})]).then(
                        function (response) {
                            scope.options = scope.options.concat(response[0].results);
                            scope.loading = false;
                        },
                        function (response) {
                            scope.loading = false;
                        }
                    );
                }

                function search($select) {
                    if (!scope.withLoading) {
                        return;
                    }

                    if (scope.loading) {
                        return;
                    }

                    if (!scope.onSearch) {
                        return;
                    }

                    scope.page = 1;
                    scope.loading = true;

                    var data = {};
                    data[scope.queryProp] = $select.search;

                    $q.all([scope.onSearch({params: data})]).then(
                        function (response) {
                            scope.options = response[0].results;
                            scope.loading = false;
                        },
                        function (response) {
                            scope.loading = false;
                        }
                    );
                }

                function evalOptionFilter(item) {
                    if (scope.optionFilter) {
                        return scope.optionFilter({
                            item: item
                        });
                    } else {
                        return true;
                    }
                }

                function isWithLabel() {
                    return scope.fullWidth === undefined ? true : scope.withLabel;
                }

                function getLabelClass() {
                    if (scope.labelClass) {
                        return scope.labelClass;
                    } else {
                        return isWithLabel() ? 'col-sm-2' : '';
                    }
                }

                function getContainerClass() {
                    if (scope.containerClass) {
                        return scope.containerClass;
                    } else {
                        return isWithLabel() ? 'col-sm-10' : 'col-sm-12';
                    }
                }

                function onBlur(isOpen, $select) {
                    if (!isOpen && !isArrayEqual($select.selected, _selected)) {
                        if (scope.onChange) {
                            scope.onChange();
                        }
                    }
                    _selected = angular.copy($select.selected);
                }

                function onItemRemove() {
                    scope.$apply(function () {
                        if (scope.onChange) {
                            scope.onChange();
                        }
                    });
                }

                function isArrayEqual(x, y) {
                  return lodashService(x).differenceWith(y, lodashService.isEqual).isEmpty();
                }

                function clearAll() {
                    if (scope.object[scope.prop].length !== 0) {
                        scope.object[scope.prop] = [];
                        _selected = [];
                        if (scope.onChange) {
                            scope.onChange();
                        }
                    }
                }

                function getItem(item) {
                    return scope.selectObject ? item : item[scope.optionPropValue];
                }

                function getItemTitle(item) {
                    var title = '';

                    if (scope.optionPropExtraPk) {
                        title = title + '[' + item[scope.optionPropExtraPk] + '] ';
                    }

                    if (scope.optionPropExtraTitle) {
                        title = title + item[scope.optionPropExtraTitle] + ' ';
                    }

                    title = title + '[' + item.pk + '] ' + item[scope.optionPropTitle];

                    return title;
                }
            }
        };
    }
})();
